module.exports = __webpack_public_path__ + "static/img/dt.2984cdf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dt.gif
// module id = RtJt
// module chunks = 1